import { useEffect, useState } from "react";
import { useShiftPageStyles } from "pages/ShiftReports/styles";

export const useDaStatusHighlight = (userStatus: number) => {
  const classes = useShiftPageStyles();
  const [daStatusHighlight, setDaStatusHighlight] = useState({
    alertClassName: classes.orangeAlert,
    className: classes.yellowCell,
    disabledClass: classes.yellowDisabled,
    severity: "warning",
  });

  useEffect(() => {
    switch (userStatus) {
      case 1:
        setDaStatusHighlight({
          alertClassName: classes.greenAlert,
          className: classes.greenCell,
          disabledClass: classes.greenDisabled,
          severity: "success",
        });
        break;
      case 0:
      case 3:
        setDaStatusHighlight({
          alertClassName: classes.orangeAlert,
          className: classes.yellowCell,
          disabledClass: classes.yellowDisabled,
          severity: "warning",
        });
        break;
      default:
        setDaStatusHighlight({
          alertClassName: classes.redAlert,
          className: classes.redCell,
          disabledClass: classes.redDisabled,
          severity: "error",
        });
    }
  }, [
    userStatus,
    classes.greenAlert,
    classes.greenCell,
    classes.orangeAlert,
    classes.redAlert,
    classes.redCell,
    classes.yellowCell,
    classes.greenDisabled,
    classes.yellowDisabled,
    classes.redDisabled,
  ]);

  return daStatusHighlight;
};
